import { Input } from "@/components/ui/input";
import { Search, Store, X } from "lucide-react";
import { STATUS_CHIPS, chipClasses } from "./mobileHelpers";

/**
 * Barra de busca + chips de status/prioridade + filtro por loja (fev/2026).
 * Props: search, setSearch, filterStatus, setFilterStatus, statusCounts,
 *        empresas (list [{id, nome, count}]), filterEmpresa, setFilterEmpresa
 * O filtro de empresa só aparece quando o entregador tem entregas de 2+ lojas.
 */
export function MobileSearchAndChips({
  search, setSearch, filterStatus, setFilterStatus, statusCounts,
  empresas = [], filterEmpresa = "all", setFilterEmpresa,
}) {
  const showEmpresaFilter = empresas.length >= 2;
  const totalEmpresas = empresas.reduce((acc, e) => acc + (e.count || 0), 0);
  return (
    <>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar por pedido, cliente, bairro, telefone…"
          className="pl-9 pr-9 h-11 bg-white border-orange-200 focus-visible:ring-orange-400"
          data-testid="mobile-search-input"
          inputMode="search"
        />
        {search && (
          <button onClick={() => setSearch("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-orange-100"
            data-testid="mobile-search-clear">
            <X className="w-4 h-4 text-muted-foreground" />
          </button>
        )}
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-none">
        {STATUS_CHIPS.map((chip) => {
          const active = filterStatus === chip.k;
          const count = statusCounts[chip.k];
          return (
            <button
              key={chip.k}
              onClick={() => setFilterStatus(chip.k)}
              data-testid={`mobile-chip-${chip.k}`}
              className={`shrink-0 rounded-full border-2 px-3 h-8 text-xs font-bold transition ${chipClasses(chip, active, count)}`}
            >
              {chip.label}{typeof count === "number" && count > 0 ? ` · ${count}` : ""}
            </button>
          );
        })}
      </div>
      {showEmpresaFilter && (
        <div className="space-y-1" data-testid="mobile-empresa-filter">
          <div className="flex items-center gap-1 text-[10px] text-orange-800 font-bold uppercase tracking-wider">
            <Store className="w-3 h-3" />Filtrar por loja
          </div>
          <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-none">
            <button
              onClick={() => setFilterEmpresa("all")}
              data-testid="mobile-empresa-chip-all"
              className={`shrink-0 rounded-full border-2 px-3 h-8 text-xs font-bold transition ${filterEmpresa === "all" ? "bg-orange-600 text-white border-orange-700" : "bg-white text-orange-700 border-orange-200 hover:bg-orange-50"}`}
            >
              Todas · {totalEmpresas}
            </button>
            {empresas.map((emp) => {
              const active = filterEmpresa === emp.id;
              return (
                <button
                  key={emp.id}
                  onClick={() => setFilterEmpresa(emp.id)}
                  data-testid={`mobile-empresa-chip-${emp.id}`}
                  className={`shrink-0 rounded-full border-2 px-3 h-8 text-xs font-bold transition inline-flex items-center gap-1 ${active ? "bg-orange-600 text-white border-orange-700" : "bg-white text-orange-700 border-orange-200 hover:bg-orange-50"}`}
                >
                  <Store className="w-3 h-3" />
                  {emp.nome || "—"}{typeof emp.count === "number" && emp.count > 0 ? ` · ${emp.count}` : ""}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
